import React, { FC } from 'react';
import { Organization } from '../hooks/useGetConsumerSchedulingOrganizationQuery';
import styled from 'styled-components';
import { Col, Row } from 'antd';

interface Props {
  organization: Organization;
}

const Styles = styled.div`
  .terms-container {
    color: ${({ theme }) => theme.greyDark};
    font-size: 12px;
    padding: 16px;
    text-align: center;
    width: 100%;
  }

  .terms-link {
    color: ${({ theme }) => theme.greyDark};
  }
`;

export const Footer: FC<Props> = ({ organization }): JSX.Element | null => {
  const isAlluvium = organization.hasAlluviumRebrandFeature;
  const companyName = isAlluvium ? 'Alluvium Health' : 'Blockit, Inc.';
  const copyright = `\u00A9 2018-${new Date().getFullYear()} ${companyName}. All Rights Reserved.`;

  return (
    <Styles>
      <div className="terms-container">
        <Row>
          <Col xs={24} md={0}>
            <span>
              <a className="terms-link" href="https://www.blockitnow.com/terms">
                Terms of Service
              </a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a className="terms-link" href="https://www.blockitnow.com/use">
                Acceptable Use Policy
              </a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a className="terms-link" href="https://www.blockitnow.com/privacy">
                Privacy Policy
              </a>
            </span>
          </Col>
          <Col xs={24} md={0}>
            <span>&nbsp;&nbsp;{copyright}</span>
          </Col>
          <Col xs={0} md={24}>
            <span>
              <a className="terms-link" href="https://www.blockitnow.com/terms">
                Terms of Service
              </a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a className="terms-link" href="https://www.blockitnow.com/use">
                Acceptable Use Policy
              </a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a className="terms-link" href="https://www.blockitnow.com/privacy">
                Privacy Policy
              </a>
              &nbsp;&nbsp;{copyright}
            </span>
          </Col>
        </Row>
      </div>
      {organization.consumerSchedulingSettings?.htmlFooter ? (
        <div dangerouslySetInnerHTML={{ __html: organization.consumerSchedulingSettings.htmlFooter }} />
      ) : null}
    </Styles>
  );
};
